// Types
import { GetMediaPosts_getMediaPosts_entities } from 'api/mediaPost/types/GetMediaPosts';
// Constants
import {
  ATHLETES,
  SOCIAL_MEDIA_POST,
  VIDEO_SOCIAL_MEDIA_POST,
} from 'constants/routes';
// Helpers
import { getStreamerName } from 'helpers/streams';
// Ui
import ContentCard, { ContentType } from 'ui3/Card/ContentCard';

type MediaFeedListItemProps = {
  mediaFeed: GetMediaPosts_getMediaPosts_entities;
  // Reserve the plain-<img> SSR path for above-the-fold cards only.
  priorityImageLoading?: boolean;
};

const MediaFeedListItem = ({
  mediaFeed,
  priorityImageLoading = false,
}: MediaFeedListItemProps) => {
  const mediaFeedSlug = mediaFeed.slug;
  const storeSlug = mediaFeed.store?.slug;

  const isVideo = mediaFeed && 'video' in mediaFeed;
  const mediaPostRoute = isVideo ? VIDEO_SOCIAL_MEDIA_POST : SOCIAL_MEDIA_POST;
  const link = `${storeSlug}${mediaPostRoute}${mediaFeedSlug}`;
  const storeName = getStreamerName(mediaFeed?.store);

  const thumbnailImage = isVideo
    ? mediaFeed.thumbnailUrl || mediaFeed.video.thumbnailUrl || ''
    : mediaFeed.image.url || '';

  return (
    <div>
      <ContentCard
        type={isVideo ? ContentType.VIDEO : ContentType.IMAGE}
        imageUrl={thumbnailImage}
        linkUrl={link}
        dateTime={mediaFeed?.scheduledAt || ''}
        tzCode={mediaFeed.scheduledAtTzCode || null}
        title={mediaFeed.title || ''}
        user={storeName || ''}
        userUrl={mediaFeed.store?.slug ? `/${mediaFeed.store?.slug}` : ATHLETES}
        isPlay={isVideo}
        priorityImageLoading={priorityImageLoading}
      />
    </div>
  );
};

export default MediaFeedListItem;
